import React, { useCallback, useEffect, useState } from "react";
import RequestV2 from "../../../api/RequestV2";
import Config from "../../../utils/config";

import {
  PageBodyTitle,
  Card,
  Table,
  PageLoader,
  StatusBadge,
  Button,
  SuccessMessage,
  ErrorMessage,
} from "../../design-system";

import { theme } from "../../design-system/theme";
import styled from "styled-components";
import { CsvDown } from "v2/integrations/export";

const bp = theme.breakpoints || { sm: "640px" };

const PageWrapper = styled.div`
  max-width: 1440px;
  width: 100%;
  margin: 0 auto;
  padding: ${theme.spacing.sm} 0 0;
`;

const TopBar = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: ${theme.spacing.lg};
`;
 const ActionsRow = styled.div`
  display: flex;
  align-items: center;
  gap: ${theme.spacing.sm};
`;
export default function Form60V2() {
  const [loading, setLoading] = useState(false);
  const [form60List, setForm60List] = useState([]);
  const [message, setMessage] = useState({
  success: "",
  error: "",
});

const [dataSet, setDataSet] = useState("");
const [viewModalOpen, setViewModalOpen] = useState(false);
const [imageUrl, setImageUrl] = useState("");

const [actionModalOpen, setActionModalOpen] = useState(false);
const [selectedRow, setSelectedRow] = useState(null);
const [currentPage, setCurrentPage] = useState(1);
const [pageSize, setPageSize] = useState(10);
const [downloadParams, setDownloadParams] = useState({
  pageNo: 1,
  pageSize: 500,
});
const [totalPages, setTotalPages] = useState(1);
const [totalElements, setTotalElements] = useState(0);
const fileUrl = imageUrl || "";

const isPdf =
  fileUrl.toLowerCase().includes(".pdf") ||
  fileUrl.toLowerCase().includes("application/pdf");
 const CSV_HEADERS = [
  { label: "Name", key: "name" },
  { label: "DOB", key: "dob" },
  { label: "Status", key: "status" },
  { label: "Created At", key: "createdAt" },
  { label: "Updated At", key: "updatedAt" },
];
  const getForm60List = useCallback(
    (pageNo = currentPage, size = pageSize) => {
      setLoading(true);
      setDownloadParams({
        pageNo: 1,
        pageSize: 500,
      });
      const successHandler = (res) => {
        console.log("FORM60 RESPONSE =>", res);
        setLoading(false);

        console.log("FORM60 RESPONSE =>", res);

        const root = res?.data ?? {};

        setForm60List(res?.content || []);
        setTotalPages(res?.totalPages || 1);
        setTotalElements(res?.totalElements || 0);
      };

      const errorHandler = () => {
        setLoading(false);
      };

      const api = new RequestV2(
        "",
        successHandler,
        errorHandler
      );

      api.get(
        `${Config.apis.user.FORM60_LIST}?pageNo=${pageNo}&pageSize=${size}`
      );
    },
    [currentPage, pageSize]
  );
  const handleForm60Action = (userId, action) => {
  setMessage({
    success: "",
    error: "",
  });

  const payload = {
    userId,
    action,
  };

  const successHandler = () => {
    setMessage({
      success: `Form 60 ${action.toLowerCase()} successfully`,
      error: "",
    });

    setDataSet(String(Date.now()));

    getForm60List(currentPage, pageSize);
  };

  const errorHandler = (err) => {
    setMessage({
      success: "",
      error:
        err?.response?.data?.message ||
        err?.message ||
        "Request failed",
    });

    setDataSet(String(Date.now()));
  };

  const api = new RequestV2(
    "",
    successHandler,
    errorHandler
  );

  api.post(
    Config.apis.user.FORM60_ACTION,
    payload
  );
};
const handleView = (userId) => {
  setLoading(true);
const successHandler = (res) => {
  console.log("FORM60 VIEW RESPONSE =>", res);

  setImageUrl(
    res?.imageUrl || ""
  );

  setViewModalOpen(true);
  setLoading(false);
};

  const errorHandler = () => {
    setLoading(false);
  };

  const api = new RequestV2(
    "",
    successHandler,
    errorHandler
  );

  api.get(
    `${Config.apis.user.FORM60_VIEW}?userId=${userId}`
  );
};
  useEffect(() => {
    getForm60List(currentPage, pageSize);
  }, [currentPage, pageSize, getForm60List]);

  const columns = [
    {
      key: "name",
      label: "Name",
      render: (_, row) => row?.name || "—",
    },
    {
      key: "dob",
      label: "DOB",
      render: (_, row) => row?.dob || "—",
    },
    {
      key: "addres",
      label: "Address",
      render: (_, row) => row?.address || "—",
    },
//    {
//   key: "fileUrl",
//   label: "Document",
//   render: (_, row) => {
//     const fileUrl = row?.fileUrl;

//     const isValidUrl =
//       fileUrl &&
//       (fileUrl.startsWith("http://") ||
//         fileUrl.startsWith("https://"));

//     return isValidUrl ? (
//       <a
//         href={fileUrl}
//         target="_blank"
//         rel="noopener noreferrer"
//       >
//         View PDF
//       </a>
//     ) : (
//       "No Document"
//     );
//   },
// },
    
    {
  key: "createdAt",
  label: "Created At",
  render: (_, row) => {
    const d = row?.createdAt;
    if (!d) return "—";

    const [datePart, timePart] = d.split("T");
    const time = timePart?.split(".")?.[0] ?? "";

    return `${datePart} ${time}`;
  },
},
{
  key: "updatedAt",
  label: "Updated At",
  render: (_, row) => {
    const d = row?.updatedAt;
    if (!d) return "—";

    const [datePart, timePart] = d.split("T");
    const time = timePart?.split(".")?.[0] ?? "";

    return `${datePart} ${time}`;
  },
},
{
      key: "status",
      label: "Status",
      render: (_, row) => (
        <StatusBadge status={row?.status} />
      ),
    },
  {
  key: "actions",
  label: "Action",
  render: (_, row) => (
    <div
      style={{
        display: "flex",
        gap: "8px",
        justifyContent: "center",
      }}
    >
      {row?.status === "PENDING" && (
        <Button
          size="xs"
          variant="primary"
          onClick={() => {
            setSelectedRow(row);
            setActionModalOpen(true);
          }}
        >
          Take Action
        </Button>
      )}

      <Button
        size="xs"
        variant="secondary"
        onClick={() => handleView(row?.userId)}
      >
        View
      </Button>
    </div>
  ),
}
  ];

  if (loading && form60List.length === 0) {
    return <PageLoader />;
  }

  return (
    <PageWrapper>
      <TopBar>
  <PageBodyTitle>Form 60 Listing</PageBodyTitle>

  <ActionsRow>
    <CsvDown
      headers={CSV_HEADERS}
      url={Config.apis.user.FORM60_LIST}
      method="get"
      params={{
        pageNo: 1,
        pageSize: totalElements || 9999,
      }}
      title="CSV"
      reportName="form60.csv"
      useV2
    />
  </ActionsRow>
</TopBar>
      {message.success && (
  <SuccessMessage
    successMessage={message.success}
    dataset={dataSet}
  />
)}

{message.error && (
  <ErrorMessage
    error={message.error}
    datetimestamp={dataSet}
  />
)}
      <Card>
        <Table
          data={form60List}
          columns={columns}
          rowKey={(row, idx) => `${row?.userId}-${idx}`}
          loading={loading}
          emptyMessage="No record found"
          pagination={{
            currentPage,
            pageSize,
            total: totalElements,
            onPageChange: setCurrentPage,
            pageSizeOptions: [10, 20, 50],
            onPageSizeChange: (size) => {
              setPageSize(size);
              setCurrentPage(1);
            },
          }}
        />
      </Card>
      {actionModalOpen && (
  <div
    role="presentation"
    onClick={() => setActionModalOpen(false)}
    style={{
      position: "fixed",
      inset: 0,
      background: "rgba(0,0,0,0.4)",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      zIndex: 1000,
    }}
  >
    <div
      role="dialog"
      aria-modal="true"
      onClick={(e) => e.stopPropagation()}
      style={{
        background: "#fff",
        padding: "24px",
        borderRadius: "12px",
        width: "400px",
      }}
    >
      <h3>Take Action</h3>

      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginTop: "20px",
        }}
      >
        <Button
          variant="secondary"
          onClick={() => {
            handleForm60Action(
              selectedRow?.userId,
              "REJECTED"
            );
            setActionModalOpen(false);
          }}
        >
          Reject
        </Button>

        <Button
          variant="primary"
          onClick={() => {
            handleForm60Action(
              selectedRow?.userId,
              "APPROVED"
            );
            setActionModalOpen(false);
          }}
        >
          Approve
        </Button>
      </div>
    </div>
  </div>
)}
{viewModalOpen && (
  <div
    role="presentation"
    onClick={() => setViewModalOpen(false)}
    style={{
      position: "fixed",
      inset: 0,
      background: "rgba(0,0,0,0.4)",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      zIndex: 1000,
    }}
  >
    <div
      role="dialog"
      aria-modal="true"
      onClick={(e) => e.stopPropagation()}
      style={{
        background: "#fff",
        padding: "24px",
        borderRadius: "12px",
        maxWidth: "750px",
        width: "90%",
      }}
    >
      <h3>Form 60 File</h3>

      {fileUrl ? (
  isPdf ? (
    <iframe
      src={fileUrl}
      title="Form60 PDF"
      width="100%"
      height="500px"
      style={{
        border: "none",
        borderRadius: "8px",
      }}
    />
  ) : (
    <img
      src={fileUrl}
      alt="Form60"
      style={{
        width: "100%",
        maxHeight: "500px",
        objectFit: "contain",
      }}
    />
  )
) : (
  <p>No document available</p>
)}
      <div
        style={{
          marginTop: "16px",
          textAlign: "right",
        }}
      >
        <Button
          variant="secondary"
          onClick={() => setViewModalOpen(false)}
        >
          Close
        </Button>
      </div>
    </div>
  </div>
)}
    </PageWrapper>
  );
}